import React, { useState, useEffect } from "react";
import Separator from "../General/Separator";
import { COLORS } from "../../globalvariables";
import { AnimatePresence, motion } from "framer-motion"; // tout en haut de ton fichier si pas déjà là

// Props: title, partnersData, tabTexts ({stores, designers, recycling})
function PromessesSection({ title, partnersData, tabTexts }) {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [activeCategory, setActiveCategory] = useState("stores");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredTopSection, setHoveredTopSection] = useState(false);
  const [currentHoverTextIndex, setCurrentHoverTextIndex] = useState(0);
  const [lockedHover, setLockedHover] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const visibleCategory = hoveredCategory || activeCategory;
  const adjustedWidth =
    partnersData[activeCategory]?.bottomImages?.length < 5 ? "55%" : "75%";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const sectionElement = document.getElementById("promesses");
    if (sectionElement) {
      observer.observe(sectionElement);
    }

    return () => {
      if (sectionElement) {
        observer.unobserve(sectionElement);
      }
    };
  }, []);

  useEffect(() => {
    if (!hoveredTopSection) return;
  
    const interval = setInterval(() => {
      setCurrentHoverTextIndex((prev) => (prev + 1) % 2);
    }, 2000);
  
    return () => clearInterval(interval);
  }, [hoveredTopSection]);

  const handleHover = (category) => {
    if (!lockedHover && category !== activeCategory) {
      setHoveredCategory(category);
    }
  };

  const handleMouseLeave = () => {
    if (!lockedHover) {
      setHoveredCategory(null);
    }
  };

  const handleClick = (category) => {
    setLockedHover(true);
    setActiveCategory(category);
    setHoveredCategory(null);
    setTimeout(() => setLockedHover(false), 500);
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  if (!partnersData || Object.keys(partnersData).length === 0) {
    return (
      <div className="text-center py-10" style={{ color: COLORS.textPrimary }}>
        Loading promesses...
      </div>
    );
  }

  return (
    <section
      id="promesses"
      className="py-8 md:py-16 px-2 md:px-4"
      style={{ color: COLORS.textPrimary }}
    >
      {title && (
        <motion.h3
          className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-20"
          style={{ 
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: window.innerWidth <= 768 ? "2rem" : "5rem",
            fontSize: window.innerWidth <= 768 ? "1.8rem" : "2.5rem",
            background: `linear-gradient(to right, ${COLORS.textPrimary}, ${COLORS.primary} 20%, ${COLORS.textPrimary})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundSize: "200% 100%", // ↪️ effet de dégradé serré
            backgroundPosition: "center", // ↪️ centré
          }}
        >
          {title}
          <div
            style={{
              height: "3px",
              width: "60px",
              background: COLORS.primary,
              borderRadius: "3px",
              margin: "8px auto 0",
            }}
          />
        </motion.h3>
      )}

      {/* Top Images */}
      <div
        className="relative flex justify-center mx-auto px-2"
        style={{ width: window.innerWidth <= 768 ? "95%" : "75%" }}
        onMouseEnter={() => setHoveredTopSection(true)}
        onMouseLeave={() => setHoveredTopSection(false)}
      >
        <div className="relative flex justify-between w-full">
          {partnersData[visibleCategory].topImages.map((image, index, arr) => (
            <div
              key={index}
              className="relative flex-1 overflow-hidden"
              style={{ aspectRatio: window.innerWidth <= 768 ? "3 / 4" : "4 / 3" }}
            >
              <img
                src={image}
                alt={`Top ${index}`}
                className="object-cover w-full h-full transition-opacity duration-300 ease-in-out"
                style={{
                  //  opacity: 0.8,
                  borderTopLeftRadius: index === 0 ? (window.innerWidth <= 768 ? "15px" : "20px") : "0px",
                  borderBottomLeftRadius: index === 0 ? (window.innerWidth <= 768 ? "15px" : "20px") : "0px",
                  borderTopRightRadius:
                    index === arr.length - 1 ? (window.innerWidth <= 768 ? "15px" : "20px") : "0px",
                  borderBottomRightRadius:
                    index === arr.length - 1 ? (window.innerWidth <= 768 ? "15px" : "20px") : "0px",
                }}
              />
            </div>
          ))}

          <div
            className="absolute inset-0 flex justify-center items-center transition-opacity duration-300 ease-in-out"
            style={{ 
              zIndex: hoveredTopSection ? 2 : 0,
              backgroundColor: hoveredTopSection
                ? "rgba(0, 0, 0, 0.7)"
                : "transparent",
              opacity: hoveredTopSection ? 1 : 0,
              borderTopLeftRadius: window.innerWidth <= 768 ? "15px" : "20px",
              borderBottomLeftRadius: window.innerWidth <= 768 ? "15px" : "20px",
              borderTopRightRadius: window.innerWidth <= 768 ? "15px" : "20px",
              borderBottomRightRadius: window.innerWidth <= 768 ? "15px" : "20px",
            }}
          >
            <AnimatePresence>
  <motion.div
    key={currentHoverTextIndex}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.35, ease: [0.25, 1, 0.5, 1] }} // ease-out expo style
    style={{
      position: "absolute",
      width: "100%",
      display: "flex",
      justifyContent: "center",
                  alignItems: "center",
    }}
  >
    <p
      className={`font-bold ${window.innerWidth <= 768 ? 'text-sm' : 'text-xl'} px-4 text-center`}
      style={{
        color: COLORS.creamText,
        textShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
        letterSpacing: "0.03em",
      }}
    >
                  {
                    partnersData[visibleCategory].hoverTexts[
                      currentHoverTextIndex
                    ]
                  }
    </p>
  </motion.div>
</AnimatePresence>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div
        className="relative flex justify-between mt-4 mb-4 mx-auto px-2"
        style={{ width: window.innerWidth <= 768 ? "95%" : "75%" }}
      >
        {["stores", "fashionDesigners", "recyclingCompanies"].map(
          (category, i) => (
            <div
              key={category}
              className="text-center flex-1"
              style={{
                width: window.innerWidth <= 768 ? "auto" : "300px",
                marginLeft: i === 0 && window.innerWidth > 768 ? "20px" : undefined,
                marginRight: i === 2 && window.innerWidth > 768 ? "20px" : undefined,
              }}
            >
              <button
                className={`${window.innerWidth <= 768 ? 'text-sm' : 'text-xl'} font-semibold focus:outline-none transition-colors duration-300`}
                onMouseEnter={() => handleHover(category)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleClick(category)}
                style={{ 
                  lineHeight: window.innerWidth <= 768 ? "1.8rem" : "2.2rem", 
                  whiteSpace: window.innerWidth <= 768 ? "normal" : "nowrap",
                  color:
                    (category === activeCategory && !hoveredCategory) ||
                    (category === hoveredCategory &&
                      category !== activeCategory)
                        ? COLORS.creamText
                        : COLORS.textPrimary,
                  borderBottom:
                    (category === activeCategory && !hoveredCategory) ||
                    (category === hoveredCategory &&
                      category !== activeCategory)
                            ? `2px solid ${COLORS.primary}` 
                      : "2px solid transparent",
                  textShadow:
                    (category === activeCategory && !hoveredCategory) ||
                    (category === hoveredCategory &&
                      category !== activeCategory)
                            ? `0 0 5px ${COLORS.primaryHover}`
                      : "none",
                }}
              >
                {
                  tabTexts[
                    category === "fashionDesigners"
                      ? "designers"
                      : category === "recyclingCompanies"
                      ? "recycling"
                      : "stores"
                  ]
                }
              </button>
            </div>
          )
        )}
      </div>

      <Separator activeCategory={activeCategory} />

      {/* Bottom Images */}
      <div
  className="rounded-lg transition-all opacity-80 duration-700 ease-in-out mx-2"
  style={{
    width: window.innerWidth <= 768 ? "95%" : adjustedWidth,
    margin: "0 auto",
    backgroundColor: "transparent",
    paddingTop: "20px",
    border: `2px solid ${COLORS.primary}`,
  }}
>
  <div
    className="relative flex flex-wrap justify-center gap-2 md:gap-4 mx-auto"
    style={{
      width: "100%",
      maxWidth: window.innerWidth <= 768 ? "100%" : `${
        partnersData[activeCategory]?.bottomImages?.length * 200
      }px`,
    }}
  >
          {partnersData[activeCategory].bottomImages.map((item, index) => (
            <div
              key={index}
        className="relative group transition-all duration-500 ease-in-out"
              style={{
          width: window.innerWidth <= 768 ? "140px" : "180px",
                marginBottom: window.innerWidth <= 768 ? "15px" : "20px",
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className="relative flex items-center justify-center transition-opacity duration-300 ease-in-out"
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "1 / 1",
                  border:
                     hoveredIndex === index
                      ? `2px solid ${COLORS.primary}`
                      : "2px solid transparent",
                  borderRadius: "20px",
                }}
              >
                <img
                  src={item.src}
                  alt={item.name}
                  className="transition-opacity duration-300 ease-in-out"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "20px",
                    opacity: hoveredIndex === index ? 1 : 0.5,
                  }}
                />
              </div>
        <p
          className="mt-2 text-center font-bold whitespace-nowrap overflow-hidden text-ellipsis"
          style={{ color: COLORS.textPrimary }}
        >
                {item.name}
              </p>
              <div
                className={`transition-all duration-500 ease-in-out rounded-b-lg overflow-hidden ${
            hoveredIndex === index
              ? "max-h-screen opacity-100"
              : "max-h-0 opacity-0"
                }`}
                style={{ backgroundColor: COLORS.primary }}
              >
          <p
            className="text-center text-sm p-2"
            style={{ color: COLORS.creamText }}
          >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PromessesSection;